/**
 * @generated SignedSource<<ebd28e7cb7e515e1cbb1476ed1d67880>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ChatChannelVisibility = "private" | "public" | "%future added value";
export type ProductAppVisibility = "admin" | "all" | "membership" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type ChannelsDashboardBlockItemFragment$data = {
  readonly externalChannelId: string;
  readonly id: string;
  readonly productApp: {
    readonly badge: {
      readonly " $fragmentSpreads": FragmentRefs<"BadgeFragment">;
    };
    readonly customAppTitle: string | null;
    readonly ordering: number;
    readonly visibility: ProductAppVisibility;
  } | null;
  readonly visibility: ChatChannelVisibility;
  readonly " $fragmentType": "ChannelsDashboardBlockItemFragment";
};
export type ChannelsDashboardBlockItemFragment$key = {
  readonly " $data"?: ChannelsDashboardBlockItemFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ChannelsDashboardBlockItemFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "visibility",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ChannelsDashboardBlockItemFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "externalChannelId",
      "storageKey": null
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductApp",
      "kind": "LinkedField",
      "name": "productApp",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customAppTitle",
          "storageKey": null
        },
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "ordering",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Badge",
          "kind": "LinkedField",
          "name": "badge",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "BadgeFragment"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ChatChannel",
  "abstractKey": null
};
})();

(node as any).hash = "6f1d4be28165649f5f220c0b65393f21";

export default node;
